import { createStore } from 'vuex';
import auth from '../stores/auth';
export default createStore({
    modules: {
        auth,
    },
});
